export type FormData = Partial<{
  addonOption: { label: string; value: number };
  price: number;
  priceType: PriceTypes;
  quantity: { label: string; value: number };
  description: string;
  priceTypes: string[];

  id: number;
}>;

export type AddonType = {
  price_cents: string | number;
  price_type: PriceTypes;
  max_quantity: string | number;
  description: string;
  addonOptionId: number;
  add_on?: {
    name: string;
    allowed_price_types: string[];
  };
  name?: string;
  id?: number;
};

export type AttributeNameType = keyof Omit<AddonType, 'name'>;

export enum PriceTypes {
  PER_HOUR = 'per_hour',
  PER_BOOKING = 'per_booking',
  PER_PASSENGER = 'per_passenger',
}
